import _classCallCheck from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/shawntabrizi/Documents/GitHub/substrate-society/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
// Copyright 2017-2021 @polkadot/types authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { u8aToHex } from '@polkadot/util';
import { Struct } from "../codec/Struct.mjs"; // We explicitly cast the type here to get the actual TypeScript exports right
// We can ignore the properties, added via Struct.with

var _Payload = Struct.with({
  address: 'Address',
  blockHash: 'Hash',
  blockNumber: 'BlockNumber',
  era: 'ExtrinsicEra',
  genesisHash: 'Hash',
  method: 'Call',
  nonce: 'Compact<Index>',
  runtimeVersion: 'RuntimeVersion',
  signedExtensions: 'Vec<Text>',
  tip: 'Compact<Balance>',
  version: 'u8'
});
/**
 * @name GenericSignerPayload
 * @description
 * A generic signer payload that can be used for serialization between API and signer
 */


export var GenericSignerPayload =
/*#__PURE__*/
function (_Payload2) {
  _inherits(GenericSignerPayload, _Payload2);

  function GenericSignerPayload() {
    _classCallCheck(this, GenericSignerPayload);

    return _possibleConstructorReturn(this, _getPrototypeOf(GenericSignerPayload).apply(this, arguments));
  }

  _createClass(GenericSignerPayload, [{
    key: "toPayload",

    /**
     * @description Creates an representation of the structure as an ISignerPayload JSON
     */
    value: function toPayload() {
      var address = this.address,
          blockHash = this.blockHash,
          blockNumber = this.blockNumber,
          era = this.era,
          genesisHash = this.genesisHash,
          method = this.method,
          nonce = this.nonce,
          _this$runtimeVersion = this.runtimeVersion,
          specVersion = _this$runtimeVersion.specVersion,
          transactionVersion = _this$runtimeVersion.transactionVersion,
          signedExtensions = this.signedExtensions,
          tip = this.tip,
          version = this.version;
      return {
        address: address.toString(),
        blockHash: blockHash.toHex(),
        blockNumber: blockNumber.toHex(),
        era: era.toHex(),
        genesisHash: genesisHash.toHex(),
        method: method.toHex(),
        nonce: nonce.toHex(),
        signedExtensions: signedExtensions.map(function (e) {
          return e.toString();
        }),
        specVersion: specVersion.toHex(),
        tip: tip.toHex(),
        transactionVersion: transactionVersion.toHex(),
        version: version.toNumber()
      };
    }
    /**
     * @description Creates a representation of the payload in raw Exrinsic form
     */

  }, {
    key: "toRaw",
    value: function toRaw() {
      var payload = this.toPayload(); // NOTE Explicitly pass the bare flag so the method is encoded un-prefixed (non-decodable, for signing only)

      var data = u8aToHex(this.registry.createType('ExtrinsicPayload', payload, {
        version: payload.version
      }).toU8a({
        method: true
      }));
      return {
        address: payload.address,
        data: data,
        type: 'payload'
      };
    }
  }]);

  return GenericSignerPayload;
}(_Payload);